<template>
    <div class="page-container">
        <van-nav-bar title="订单详情" fixed left-arrow @click-left="goableBack()"></van-nav-bar>
        <van-cell class="address" center >
            <img slot="icon" class="left-icon mr-20" :src="require('@/assets/img/shop/icon-address.png')">
            <div >
                <div class=" fs-16">{{order.receiveName}} <span class="fs-14 color-gray-dark">{{order.phone}}</span></div>
                <div class=" fs-14">{{order.address}}</div>
            </div>
        </van-cell>
        <div class="mt-10 p-20 bg-color-white product">
            <div class="flex-row flex-a-c">
                <div class="left mr-20">
                    <img :src="order.coverImg">
                </div>
                <div class="right">
                    <div class="mt-10 flex-row flex-j-sb flex-a-c">
                        <div class="fs-16">{{order.title}}</div>

                    </div>
                    <div class="mt-10 flex-row flex-j-sb flex-a-c">
                        <div class="fs-16">{{order.price}} 积分<span class="fs-14 color-gray-dark ml-10">x{{order.num}}</span></div>
                        <div>
                            <div class="color-red ml-10">{{status}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-20 pt-10 flex-row flex-j-sb flex-a-c van-hairline--top">
                <div class="fs-12"> <span v-show="order.status == 10">我们将为您尽快安排发货</span></div>
                <div>
                    <!--<van-button v-if="order.status == 0" @click="orderCancel" size="small"  class="ml-10"  plain >取消订单</van-button>-->
                    <van-button v-if="order.status == 0" :to="{name:'shop-pay',params:{id:order.id}}" size="small" class="ml-10" type="danger" >立即付款</van-button>
                    <!--<van-button v-if="[1,10,11].indexOf(order.status) > -1" :to="{name:'shop-after-refund',params:{id:order.id}}" size="small" class="ml-10"  round plain >申请售后</van-button>-->
                    <van-button v-if="order.status == 11" @click="orderReceive" size="small" class="ml-10" type="danger"  >确认收货</van-button>
                    <!--<van-button v-if="order.status == 12" :to="{name:'shop-after-refund',params:{id:order.id}}" size="small" class="ml-10"  plain >申请售后</van-button>
                    <van-button v-if="order.status == 12" :to="{name:'shop-after-refund',params:{id:order.id}}" size="small" class="ml-10"  plain >申请售后</van-button>
                    <van-button v-if="order.status == 30" :to="{name:'shop-after-refund-view',params:{id:order.id}}" size="small" class="ml-10"  plain >申请售后</van-button>
                    <van-button v-if="order.status == 31" :to="{name:'shop-after-refund-view',params:{id:order.id}}" size="small" class="ml-10"  plain >申请售后</van-button>-->
                </div>
            </div>
        </div>
        <div class="mt-10 bg-color-white">
            <van-cell title="商品价格" :value='`${order.payAmount} 积分`'></van-cell>
            <van-cell title="运费" value="0.00 元"></van-cell>
            <van-cell  class="total" title="订单总价" :value="`${order.payAmount} 积分`"></van-cell>
        </div>
        <div  class="mt-10 bg-color-white p-20 info">
            <div class="fs-16 color-black title">订单信息</div>
            <div class="mt-10 ml-10 color-gray-dark">订单编号: {{order.id}}</div>
            <div class="mt-5 ml-10 color-gray-dark">创建时间: {{order.createTime}}</div>
        </div>

        <div v-if="[11,12].indexOf(order.status)>-1" class="mt-10 bg-color-white p-20 info">
            <div class="fs-16 color-black title">物流信息</div>
            <div class="mt-10 ml-10 color-gray-dark">快递公司: {{order.express}}</div>
            <div class="mt-5 ml-10 color-gray-dark">快递单号: {{order.waybillNo}}</div>
        </div>
    </div>

</template>

<script>
    import {Cell, NavBar, Stepper, Button, Toast, Tag, } from "vant";
    import * as GoodsApi from '@/api/goods';

    export default {
        name: "order-view",
        data: () => ({
            order:{},
            form: {
                fields: {
                    num: "",
                    addressId:"",
                    skuId:""
                },
            }
        }),
        beforeRouteEnter(to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                next(vm => {
                    vm.setData(data);
                })
            })

        },
        beforeRouteUpdate (to, from, next) {
            GoodsApi.getOrder(to.params.id).then(data=>{
                this.setData(data);
                next();
            });
        },
        computed:{
            total:function () {
                return this.form.fields.num * this.goods.price;
            },
            status:function () {
                let statusMap = {
                    0:"待付款",
                    1:"付款中",
                    10:"待发货",
                    11:"待收货",
                    12:"已完成",
                    20:"已取消",
                    30:"退货中",
                    31:"已退款",

                };
                return statusMap[this.order.status];
            },
        },
        methods: {
            setData(data) {
                this.order = data;
            },

            orderCancel() {

            },
            orderReceive() {
                GoodsApi.confirmOrder(this.order.id).then(data=>{
                    if(data !== false) {
                        this.order.status = 12;
                    }
                }).catch(e=>{
                    Toast(e.msg);
                })
            }
        },
        components: {
            [Cell.name]: Cell,
            [NavBar.name]: NavBar,
            [Stepper.name]: Stepper,
            [Button.name]: Button,
            [Toast.name]: Toast ,
            [Tag.name]: Tag ,

        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0;
        box-sizing: border-box;
    }

    .address {
        .left-icon {
            width: 30px;
            height: auto;
        }

        .van-cell__value {

        }
    }

    .product {
        .left {
            width: 25vw;
            img {
                width: 100%;
                height: auto;
            }
        }
        .right {
            flex: 1;
        }
    }

    .total {
        font-size: 18px;
        .van-cell__value {
            color: #323233;
        }
    }
    .info {
        .title {
            position: relative;
            padding-left: 5px;
            &::before {
                position: absolute;
                top:6px;
                left: 0;
                width: 2px;
                background-color: @red;
                height: 14px;
                content: '';
            }
        }
    }

</style>